module.exports = __webpack_public_path__ + "static/cloud-hero-ccd44b6b493fb95ca853e8a01f8cc859.png";